import { i18n } from '@atlas-frontend/i18n';
import i18next from 'i18next';
import { useState } from 'react';

export const useCurrentLocale = () => {
  const [locale, setLocale] = useState(i18n.language);
  i18next.on('languageChanged', setLocale);
  return locale;
};
